type Week = {
  n: number;
  phase: string;
  miles: number;
  cut?: boolean;
  current?: boolean;
};

const WEEKS: Week[] = [
  { n: 1, phase: "Base", miles: 14 },
  { n: 2, phase: "Base", miles: 17 },
  { n: 3, phase: "Base", miles: 20 },
  { n: 4, phase: "Base", miles: 16, cut: true },
  { n: 5, phase: "Build", miles: 23 },
  { n: 6, phase: "Build", miles: 26 },
  { n: 7, phase: "Build", miles: 29 },
  { n: 8, phase: "Build", miles: 22, cut: true },
  { n: 9, phase: "Build", miles: 31 },
  { n: 10, phase: "Peak", miles: 34 },
  { n: 11, phase: "Peak", miles: 37, current: true },
  { n: 12, phase: "Peak", miles: 28, cut: true },
  { n: 13, phase: "Peak", miles: 38 },
  { n: 14, phase: "Peak", miles: 40 },
  { n: 15, phase: "Taper", miles: 30 },
  { n: 16, phase: "Taper", miles: 22 },
  { n: 17, phase: "Taper", miles: 14 },
  { n: 18, phase: "Race", miles: 27 },
];

export function ScreenPlan() {
  return (
    <div
      className="mfm-screen"
      data-mode="light"
      data-accent="burgundy"
      style={{ width: "100%", height: "100%", padding: "108px 0 0", overflow: "hidden" }}
    >
      <div style={{ padding: "0 24px 16px" }}>
        <div className="eyebrow">The Plan</div>
        <div
          className="serif"
          style={{ fontSize: 32, lineHeight: 1, letterSpacing: "-0.02em", color: "var(--text)", marginTop: 6 }}
        >
          Eighteen chapters.
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {WEEKS.map((w) => (
          <div
            key={w.n}
            style={{
              display: "grid",
              gridTemplateColumns: "64px 1fr auto",
              alignItems: "baseline",
              padding: "14px 24px",
              borderTop: w.n === 1 ? "0.5px solid var(--hairline)" : "none",
              borderBottom: "0.5px solid var(--hairline)",
              background: w.current ? "var(--accent-soft)" : "transparent",
              color: w.current ? "var(--text)" : w.n > 11 ? "var(--text-3)" : "var(--text)",
              position: "relative",
            }}
          >
            {w.current && (
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: 3,
                  background: "var(--accent)",
                }}
              />
            )}
            <div
              className="serif tnum"
              style={{
                fontSize: 22,
                letterSpacing: "-0.01em",
                color: w.current ? "var(--accent)" : "inherit",
              }}
            >
              {String(w.n).padStart(2, "0")}
            </div>
            <div
              style={{
                fontFamily: "var(--ui)",
                fontSize: 14,
                color: w.current ? "var(--text)" : "var(--text-2)",
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                fontWeight: w.current ? 600 : 500,
              }}
            >
              {w.phase}
              {w.cut ? " · cut-back" : ""}
            </div>
            <div
              className="tnum"
              style={{
                fontFamily: "var(--ui)",
                fontSize: 14,
                color: w.current ? "var(--accent)" : "var(--text-2)",
                fontVariantNumeric: "tabular-nums",
                fontWeight: w.current ? 600 : 400,
              }}
            >
              {w.miles} mi
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
